import React from 'react';

const iconPaths = {
  search: (
    <>
      <circle cx='11' cy='11' r='6.5' />
      <path d='m16 16 4 4' />
    </>
  ),
  close: (
    <>
      <path d='M6 6l12 12' />
      <path d='M18 6 6 18' />
    </>
  ),
  'chevron-down': <path d='m6 9 6 6 6-6' />,
  'chevron-up': <path d='m6 15 6-6 6 6' />,
  'chevron-left': <path d='m15 6-6 6 6 6' />,
  'chevron-right': <path d='m9 6 6 6-6 6' />,
  'caret-down': <path d='m8 10 4 5 4-5' />,
  info: (
    <>
      <circle cx='12' cy='12' r='8.5' />
      <path d='M12 10v5' />
      <path d='M12 7.5h.01' />
    </>
  ),
  calendar: (
    <>
      <path d='M7 4v3' />
      <path d='M17 4v3' />
      <rect x='4' y='6.5' width='16' height='13.5' rx='2.5' />
      <path d='M4 10.5h16' />
    </>
  ),
  clock: (
    <>
      <circle cx='12' cy='12' r='8.5' />
      <path d='M12 7.5v5l3 1.75' />
    </>
  ),
  rocket: (
    <>
      <path d='M6 14c1.5-4.5 5.5-8.5 10-10 1.25 4.5-.75 9.25-5 13.5L8 20l-1-3-3-1 2-2Z' />
      <circle cx='14.5' cy='9.5' r='1.25' />
    </>
  ),
  globe: (
    <>
      <circle cx='12' cy='12' r='8.5' />
      <path d='M3.5 12h17' />
      <path d='M12 3.5c2.5 2.3 4 5.3 4 8.5s-1.5 6.2-4 8.5c-2.5-2.3-4-5.3-4-8.5s1.5-6.2 4-8.5Z' />
    </>
  ),
  users: (
    <>
      <path d='M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z' />
      <path d='M17 12a2.75 2.75 0 1 0 0-5.5 2.75 2.75 0 0 0 0 5.5Z' />
      <path d='M3.5 20a5.5 5.5 0 0 1 11 0' />
      <path d='M13.5 19.5a4.5 4.5 0 0 1 7 0' />
    </>
  ),
  'user-plus': (
    <>
      <path d='M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z' />
      <path d='M3.5 20a5.5 5.5 0 0 1 11 0' />
      <path d='M18 8v6' />
      <path d='M15 11h6' />
    </>
  ),
  user: (
    <>
      <path d='M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z' />
      <path d='M4 20a8 8 0 0 1 16 0' />
    </>
  ),
  list: (
    <>
      <path d='M9 7h10' />
      <path d='M9 12h10' />
      <path d='M9 17h10' />
      <path d='M5 7h.01' />
      <path d='M5 12h.01' />
      <path d='M5 17h.01' />
    </>
  ),
  edit: (
    <>
      <path d='m4 20 4.25-1 9-9a2.12 2.12 0 1 0-3-3l-9 9L4 20Z' />
      <path d='m13.5 7.5 3 3' />
    </>
  ),
  download: (
    <>
      <path d='M12 4.5v10' />
      <path d='m7.5 10.5 4.5 4.5 4.5-4.5' />
      <path d='M5 19.5h14' />
    </>
  ),
  upload: (
    <>
      <path d='M12 19.5v-10' />
      <path d='m7.5 13.5 4.5-4.5 4.5 4.5' />
      <path d='M5 4.5h14' />
    </>
  ),
  plus: (
    <>
      <path d='M12 5v14' />
      <path d='M5 12h14' />
    </>
  ),
  'minus-circle': (
    <>
      <circle cx='12' cy='12' r='8.5' />
      <path d='M8 12h8' />
    </>
  ),
  trash: (
    <>
      <path d='M5 7h14' />
      <path d='M9 7V5h6v2' />
      <path d='M8 7v12' />
      <path d='M16 7v12' />
      <path d='M6.5 19h11' />
      <path d='M11 10.5v5.5' />
      <path d='M13 10.5v5.5' />
    </>
  ),
  filter: (
    <>
      <path d='M4 6h16' />
      <path d='M7 12h10' />
      <path d='M10 18h4' />
    </>
  ),
  inbox: (
    <>
      <path d='M4.5 6.5h15l1.5 8v4h-18v-4l1.5-8Z' />
      <path d='M7.5 13.5h9' />
      <path d='M10 10.5 12 8l2 2.5' />
    </>
  ),
  phone: (
    <>
      <path d='M7.5 5.5c.3 5.2 5.8 10.7 11 11' />
      <path d='M17.5 20c-6.4-.4-13.1-7.1-13.5-13.5a1.8 1.8 0 0 1 1.5-1.9l3-.5 1.5 4-2 1.5a11.6 11.6 0 0 0 4.4 4.4l1.5-2 4 1.5-.5 3a1.8 1.8 0 0 1-1.9 1.5Z' />
    </>
  ),
  mail: (
    <>
      <rect x='4' y='6' width='16' height='12' rx='2.5' />
      <path d='m5.5 7.5 6.5 5 6.5-5' />
    </>
  ),
  sync: (
    <>
      <path d='M20 7.5V4l-3 3' />
      <path d='M17 7a7 7 0 0 0-11.5 2' />
      <path d='M4 16.5V20l3-3' />
      <path d='M7 17a7 7 0 0 0 11.5-2' />
    </>
  ),
  more: (
    <>
      <circle cx='5' cy='12' r='1.5' fill='currentColor' stroke='none' />
      <circle cx='12' cy='12' r='1.5' fill='currentColor' stroke='none' />
      <circle cx='19' cy='12' r='1.5' fill='currentColor' stroke='none' />
    </>
  ),
  spinner: (
    <>
      <path d='M12 4a8 8 0 1 0 8 8' />
    </>
  ),
};

const DSIcon = ({
  name = 'search',
  className = '',
  title,
  size = 16,
  strokeWidth = 1.85,
  spin = false,
  style,
  ...props
}) => {
  const svgClassName = `${spin ? 'animate-spin ' : ''}${className}`.trim();

  return (
    <svg
      viewBox='0 0 24 24'
      width={size}
      height={size}
      fill='none'
      stroke='currentColor'
      strokeWidth={strokeWidth}
      strokeLinecap='round'
      strokeLinejoin='round'
      className={svgClassName}
      style={style}
      aria-hidden={title ? undefined : 'true'}
      role={title ? 'img' : undefined}
      {...props}
    >
      {title ? <title>{title}</title> : null}
      {iconPaths[name] || iconPaths.search}
    </svg>
  );
};

export default DSIcon;
